export const DEFAULT_STATE = {
    data: null,
    dataDetail: null,
    dataDetailSa: null,
    isLoading: false,
    publisherIdSelected: null,
};
